import React, { Component } from "react";
import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import Responsive from "react-responsive";
import AppBar from '@material-ui/core/AppBar';
import CircularProgress  from "@material-ui/core/CircularProgress";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

import Button from "@material-ui/core/Button";
import moment from "moment";

import BedsAvailabilityCard from "./BedsAvailabilityCard/BedsAvailabilityCard";

import BedsAvailabilityCardBar from "./BedsAvailabilityCardBar/BedsAvailabilityCardBar";
import InternmentRequestModal from "./InternmentRequestModal/InternmentRequestModal";
import {
  getNow,
  getTimeFrame
} from "./../services/dashboard";
import AppTheme from "../AppTheme";
import styles from "./BedsDashboardStyle";
import PublicClaimsDashboard from "../PublicClaimsDashboard";

import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";

import ClaimsList from "../ClaimsDashboard/ClaimsList";
import {
  getClaimCardsData,
  toggleCardExpansion,
  resolveClaim,
  deleteClaim
} from "../ClaimsDashboard/ClaimsDashboardContent/ClaimCards.logic";
import PropTypes from "prop-types";
import * as ClaimsService from "../services/claims";

const Desktop = props => <Responsive {...props} minWidth={1441} />;
const Tablet = props => (
  <Responsive {...props} minWidth={750} maxWidth={1440} />
);
const Mobile = props => <Responsive {...props} maxWidth={749} />;

class BedsDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestModalOpen: false,
      requestClaimCloseOpen: false,
      loaded:false,
      interval: null,
      expandedCardList: []
    };
    this.enableAutoload = this.enableAutoload.bind(this);
    this.disableAutoload = this.disableAutoload.bind(this);
    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleClaimClose = this.handleClaimClose.bind(this);
  }
  //  static propTypes = {
  //    claims: PropTypes.arrayOf(PropTypes.object).isRequired,
  //    counties: PropTypes.arrayOf(PropTypes.object).isRequired,
  //    countyFilter: PropTypes.string,
  //    reasonFilter: PropTypes.string,

  //    handleResolveClaim: PropTypes.func.isRequired,
  //  };

  static defaultProps = {
    countyFilter: "all",
    reasonFilter: "Toate"
  };

  enableAutoload() {
    const setTimer = window.setInterval(() => {
      this.iRunEveryFiveMinutes();
    }, 300000);
    this.setState({ interval: setTimer });
  }

  disableAutoload() {
    //console.log("Clearing the timer from state...");
    const clearTimer = window.clearInterval(this.state.interval);
    this.setState({ interval: clearTimer });
  }

  async iRunEveryFiveMinutes() {
    await this.initialLoad();
    //console.log("Hello There. We refreshed the bed occupancy", new Date());
  }

  async initialLoad() {
    const now = await getNow();
    if (now.error) {
      this.setState({ error: now.error, refresh: false});
      return;
    } else {
      this.setState({ error: null });
    }

    const claims = await ClaimsService.getAllClaims();
    const claimsNo = getClaimCardsData({
      claims,
      expandedCardList: this.state.expandedCardList,
      county: "all",
      reason: "Toate"
    }).length;

    
    if (now && now.spital) {
    
      now.spital.sectii.numarPaturi = 22;
      if (
        now.spital.sectii.numarPaturiOcupate > now.spital.sectii.numarPaturi
      ) {
        now.spital.sectii.numarPacienti = now.spital.sectii.numarPaturiOcupate;
        now.spital.sectii.numarPaturiLibere = 0;
        now.spital.sectii.supraAlocare =
          now.spital.sectii.numarPaturiOcupate - now.spital.sectii.numarPaturi;
        now.spital.sectii.numarPaturiOcupate = now.spital.sectii.numarPaturi;
      } else {
        now.spital.sectii.numarPacienti = now.spital.sectii.numarPaturiOcupate;
        now.spital.sectii.numarPaturiLibere =
          now.spital.sectii.numarPaturi - now.spital.sectii.numarPaturiOcupate;
        now.spital.sectii.supraAlocare = 0;
      }
    }

    
    
    this.setState({
      occupiedBeds: now ? now.spital.sectii.numarPaturiOcupate : 0,
      freeBeds: now ? now.spital.sectii.numarPaturiLibere : 0,
      allBeds: now ? now.spital.sectii.numarPaturi : 0,
      noOfPatients: now ? now.spital.sectii.numarPacienti : 0,
      overBeds: now ? now.spital.sectii.supraAlocare : 0,
      yesterdayBeds: now ? now.spital.sectii.numarPaturiOcupate : 0,
      nameSection: now
        ? now.spital.sectii.codDRG + " " + now.spital.sectii.denumireHMS
        : "Nu s-au putut prelua datele de la server",
      nameHospital: "Spitalul Marie Curie Bucuresti",
      dateLastUpdate: now ? now.spital.sectii.dataGenerare : new Date(),
      currentWeek: 0,
      refresh: false,
      claims: claims,
      claimsNo: claimsNo,
      inputs: now ? now.spital.sectii.intrati : 0,
      outputs: now ? now.spital.sectii.iesiti : 0,
      loaded:true,
      diagsInternments: now
        ? now.spital.sectii.diagnosticeIntrarePacientiAflati.diagnostic
        : []

    });
  }

  async componentDidMount() {
    this.enableAutoload();
    await this.initialLoad();

    this.setState({
      tabValue: 0,
      height: window.innerHeight
    });
  }

  // async setDataForCharts(weekNum) {
  //   const thisWeek = await getTimeFrame(
  //     moment()
  //       .startOf("week")
  //       .subtract(7 * weekNum, "day")
  //       .format("YYYY-MM-DD"),
  //     moment()
  //       .endOf("week")
  //       .subtract(7 * weekNum, "day")
  //       .add(1, "day")
  //       .format("YYYY-MM-DD")
  //   );
  //   let chartStatistics = { days: [], ins: [], outs: [] };
  //   let diagStatistics = { days: [], diags: [] };
  //   let avgOccupancy = { days: [], values: [], dailyValues: [] };
  //   let diagCodes = [];
  //   for (var day in thisWeek) {
  //     if (thisWeek[day].diagCodes) {
  //       diagCodes = thisWeek[day].diagCodes;
  //     }
  //   }
  //   for (var diag in diagCodes) {
  //     diagStatistics.diags.push({ name: diagCodes[diag], values: [] });
  //   }
  //   let cntDays = 0;
  //   let calculatedAverage = 0;
  //   for (var day in thisWeek) {
  //     avgOccupancy.days.push(thisWeek[day].day);
  //     avgOccupancy.dailyValues.push(thisWeek[day].dailyValues);
  //     avgOccupancy.values.push(thisWeek[day].avg);
  //     if (thisWeek[day].avg > 0.1) {
  //       cntDays += 1;
  //       calculatedAverage += thisWeek[day].avg;
  //     }
  //     chartStatistics.days.push(thisWeek[day].day);
  //     chartStatistics.ins.push(thisWeek[day].totalDiff.patientsIn);
  //     chartStatistics.outs.push(thisWeek[day].totalDiff.patientsOut);

  //     diagStatistics.days.push(thisWeek[day].day);
  //     if (thisWeek[day].diagCodes) {
  //       for (var diag in thisWeek[day].diff) {
  //         if (diagStatistics.diags[diag] && diagStatistics.diags[diag].values) {
  //           diagStatistics.diags[diag].values.push(
  //             thisWeek[day].diff[diag].patientsIn
  //           );
  //         }
  //       }
  //     } else {
  //       for (var diag in diagCodes) {
  //         diagStatistics.diags[diag].values.push(0.1);
  //       }
  //     }
  //   }

  //   if (cntDays > 0) {
  //     calculatedAverage = Math.round(calculatedAverage / cntDays, 1);
  //   }

  //   this.setState({
  //     chartStatistics: chartStatistics,
  //     diagStatistics: diagStatistics,
  //     avgOccupancy: avgOccupancy,
  //     calculatedAverage: calculatedAverage
  //   });
  // }

  handleRefresh() {
    this.setState({ refresh: true });
    //console.log("refresh");
  }


  handleTabChange = (event, value) => {
    this.setState({ tabValue: value });
  };

  handleResolveClaim = async claimId => {
    await ClaimsService.resolveClaim(claimId);

    this.setState(prevState => ({
      claims: resolveClaim(this.state.claims, claimId)
    }));
  };
  handleClaimClose = () => {
    this.setState({
      requestClaimCloseOpen: false
    });
  };
  handleClaimCloseConfirm = async (reason) => {
    await ClaimsService.deleteClaim(this.state.currentClaimId, reason);

    this.setState(prevState => ({
      claims: deleteClaim(this.state.claims, this.state.currentClaimId),
      requestClaimCloseOpen: false
    }));
  
  };
  handleDeleteClaim = async claimId => {
    this.setState({
      requestClaimCloseOpen: true,
      currentClaimId: claimId
    });
  };

  render() {
    const { classes } = this.props;
    const { tabValue, claims } = this.state;
    const { countyFilter, reasonFilter } = this.props;
    if (!this.state.loaded) {
      return (
        <MuiThemeProvider theme={AppTheme}>
          <div className={classes.spinnerContainer}>
            <div className={classes.spinner}>
              <CircularProgress size={80} />
            </div>
            <h1>Vă rugăm așteptați să se încarce informațiile</h1>
          </div>
        </MuiThemeProvider>
      );
    }
    return (
      <MuiThemeProvider theme={AppTheme}>
        <InternmentRequestModal
          open={this.state.requestModalOpen}
          onClose={this.handleRequestModalClose}
        />

        <div className={classes.bedsDashboard}>
          <AppBar className={classes.secondaryAppBar} position="static">
            <Toolbar className={classes.secondaryToolBar}>
              <div className={classes.secondaryToolBarText}>
                <Typography
                  variant="h2"
                  className={classes.secondaryAppBarTitle}
                >
                  <i className="medical-icon-hospital appToolbar-menu " />{" "}
                  Spital MS Curie București
                </Typography>
                <Typography
                  variant="h6"
                  className={classes.secondaryAppBarSubTitle}
                >
                  <i className="medical-icon-i-administration appToolbar-menu " />{" "}
                  Secția Terapie Intensivă Nou-Născuți
                </Typography>
              </div>
              <div className={classes.secondaryToolBarButtons}>
                <Button
                  variant="contained"
                  size="large"
                  color="default"
                  className={classes.buttonBar}
                  onClick={() => this.setState({ tabValue: 0 })}
                >
                  PATURI
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  color="default"
                  className={classes.buttonBar}
                  onClick={() => this.setState({ tabValue: 1 })}
                >
                  STATISTICI 
                </Button>
               
              </div>
            </Toolbar>
          </AppBar>
          {/* dashboard disponibilitate paturi */}
          {tabValue === 0 && (
            <div>
              <Desktop>
                {this.state.error && (
                  <div
                    style={{
                      padding: 30,
                      fontSize: "16px",
                      textAlign: "center",
                      color: "#ff0000"
                    }}
                  >
                    {this.state.error}
                  </div>
                )}
                <div className={classes.content}>
                  {!this.state.error && (
                    <BedsAvailabilityCardBar
                      claims={getClaimCardsData({
                        claims,
                        expandedCardList: this.state.expandedCardList,
                        countyFilter,
                        reasonFilter
                      }).length}
                      onInternmentRequest={this.handleOnInternmentRequest}
                      occupiedBeds={this.state.occupiedBeds}
                      freeBeds={this.state.freeBeds}
                      overBeds={this.state.overBeds}
                      allBeds={this.state.allBeds}
                      inputs={this.state.inputs}
                      outputs={this.state.outputs}
                      noOfPatients={this.state.noOfPatients}
                      dateLastUpdate={this.state.dateLastUpdate}
                      height={this.state.height}
                    />
                  )}

                  {!this.state.error && (
                    <ClaimsList
                      className={classes.claimsList}
                      claimCardsData={getClaimCardsData({
                        claims,
                        expandedCardList: this.state.expandedCardList,
                        countyFilter,
                        reasonFilter
                      })}
                      toggleCardExpansion={this.handleToggleCardExpansion}
                      handleResolveClaim={this.handleResolveClaim}
                      handleDeleteClaim={this.handleDeleteClaim}
                    />
                  )}
                  <Dialog
                    open={this.state.requestClaimCloseOpen}
                    maxWidth={false}
                    disableBackdropClick={true}
                  >
                    <div className={classes.header}>
                      <p className={classes.headerTitle}>
                        Inchidere cerere de internare
                      </p>
                      <IconButton
                        className={classes.headerCloseIcon}
                        onClick={this.handleClaimClose}
                      >
                        <CloseIcon/>
                      </IconButton>
                    </div>
                    <div
                      style={{
                        margin: 20,
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignContent: "stretch"
                      }}
                    >
                      <Button
                        variant="contained"
                        size="large"
                        color="default"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          this.handleClaimCloseConfirm("deces");
                        }}
                      >
                        Deces
                      </Button>
                      <Button
                        variant="contained"
                        size="large"
                        color="default"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          this.handleClaimCloseConfirm("transfer");
                        }}
                      >
                        Transfer alta institutie
                      </Button>
                      <Button
                        variant="contained"
                        size="large"
                        color="default"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          this.handleClaimCloseConfirm("stare_ameliorata");
                        }}
                      >
                        Stare ameliorata
                      </Button>
                      <Button
                        variant="contained"
                        size="large"
                        color="default"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          this.handleClaimCloseConfirm("eroare");
                        }}
                      >
                        Eroare introducere
                      </Button>
                    </div>
                  </Dialog>
                </div>
              </Desktop>
              <Tablet>
                {this.state.error && (
                  <div
                    style={{
                      padding: 30,
                      fontSize: "24px",
                      textAlign: "center",
                      color: "#ff0000"
                    }}
                  >
                    {this.state.error}
                  </div>
                )}
                <div className={classes.contentTablet}>
                  {!this.state.error && (
                    <BedsAvailabilityCardBar
                      claims={getClaimCardsData({
                        claims,
                        expandedCardList: this.state.expandedCardList,
                        countyFilter,
                        reasonFilter
                      }).length}
                      onInternmentRequest={this.handleOnInternmentRequest}
                      occupiedBeds={this.state.occupiedBeds}
                      freeBeds={this.state.freeBeds}
                      overBeds={this.state.overBeds}
                      allBeds={this.state.allBeds}
                      inputs={this.state.inputs}
                      outputs={this.state.outputs}
                      noOfPatients={this.state.noOfPatients}
                      dateLastUpdate={this.state.dateLastUpdate}
                      height={this.state.height}
                    />
                  )}

                  {!this.state.error && (
                    <ClaimsList
                      className={classes.claimsList}
                      claimCardsData={getClaimCardsData({
                        claims,
                        expandedCardList: this.state.expandedCardList,
                        countyFilter,
                        reasonFilter
                      })}
                      toggleCardExpansion={this.handleToggleCardExpansion}
                      handleResolveClaim={this.handleResolveClaim}
                      handleDeleteClaim={this.handleDeleteClaim}
                    />
                  )}
                  <Dialog
                    open={this.state.requestClaimCloseOpen}
                    maxWidth={false}
                    disableBackdropClick={true}
                  >
                    <div className={classes.header}>
                      <p className={classes.headerTitle}>
                        Inchidere cerere de internare
                      </p>
                      <IconButton
                        className={classes.headerCloseIcon}
                        onClick={this.handleClaimClose}
                      >
                        <CloseIcon/>
                      </IconButton>
                    </div>
                    <div
                      style={{
                        margin: 20,
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        alignContent: "stretch"
                      }}
                    >
                      <Button
                        variant="contained"
                        size="large"
                        color="default"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          this.handleClaimCloseConfirm("deces");
                        }}
                      >
                        Deces
                      </Button>
                      <Button
                        variant="contained"
                        size="large"
                        color="default"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          this.handleClaimCloseConfirm("transfer");
                        }}
                      >
                        Transfer alta institutie
                      </Button>
                      <Button
                        variant="contained"
                        size="large"
                        color="default"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          this.handleClaimCloseConfirm("stare_ameliorata");
                        }}
                      >
                        Stare ameliorata
                      </Button>
                      <Button
                        variant="contained"
                        size="large"
                        color="default"
                        style={{ marginBottom: 10 }}
                        onClick={() => {
                          this.handleClaimCloseConfirm("eroare");
                        }}
                      >
                        Eroare introducere
                      </Button>
                    </div>
                  </Dialog>
                </div>
              </Tablet>
              <Mobile>
                <div className={classes.contentMobile}>
                  <BedsAvailabilityCard
                  claims={getClaimCardsData({
                    claims,
                    expandedCardList: this.state.expandedCardList,
                    countyFilter,
                    reasonFilter
                  }).length}
                    className={classes.bedsAvailabilityTablet}
                    onInternmentRequest={this.handleOnInternmentRequest}
                    occupiedBeds={this.state.occupiedBeds}
                    freeBeds={this.state.freeBeds}
                    overBeds={this.state.overBeds}
                    allBeds={this.state.allBeds}
                    noOfPatients={this.state.noOfPatients}
                    dateLastUpdate={this.state.dateLastUpdate}
                  />
                </div>
              </Mobile>
            </div>
          )}
          {/* statistici cereri de internare */}
          {tabValue === 1 && <PublicClaimsDashboard />}
        </div>
      </MuiThemeProvider>
    );
  }

  handleRequestModalClose = () => {
    this.setState({
      requestModalOpen: false
    });
  };

  handleOnInternmentRequest = () => {
    this.setState({
      requestModalOpen: true
    });
  };
  handleToggleCardExpansion = id => {
    const expandedCardList = toggleCardExpansion(
      this.state.expandedCardList,
      id
    );
    this.setState({
      expandedCardList
    });
  };
}

export default withStyles(styles)(BedsDashboard);
